<template>
<layout>
        <div class="py-5 bg-light_yellow"> 
            <div class="container relative px-4 pt-5 mx-auto">
                <ButtonComponent 
                    content="Atrás" 
                    :icon="'arrow_back_ios'"
                    :link="'/'"
                    type="2"
                />
                <div class="justify-between py-5 md:flex">
                    <div class="flex">
                        <div class="flex">
                            <img
                                class="object-cover w-16 h-16 ml-4 border-2 rounded-full border-enriqueto_green"
                                :src="first_fruit.image"
                                alt=""
                            />
                            <h2 class="px-4 text-xl font-bold text-enriqueto_green">{{first_fruit.name}} <br> <span class="text-2xl ">{{usePriceFormat(first_fruit.price)}}</span></h2>
                        </div>
                        <div class="flex">
                            <img
                                class="object-cover w-16 h-16 ml-4 border-2 rounded-full border-enriqueto_green"
                                :src="second_fruit.image"
                                alt=""
                            />
                            <h2 class="px-4 text-xl font-bold text-enriqueto_green">{{second_fruit.name}} <br> <span class="text-2xl ">{{usePriceFormat(second_fruit.price)}}</span></h2>
                        </div>
                    </div>
                    <div>
                        <div class="px-1 py-2 mt-2 bg-white rounded-lg shadow md:mr-8">
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==7}" v-on:click="getReportsByDays(7)">7D</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==15}" v-on:click="getReportsByDays(15)">15D</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==30}" v-on:click="getReportsByDays(30)">1M</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==90}" v-on:click="getReportsByDays(90)">3M</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==180}" v-on:click="getReportsByDays(180)">6M</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==365}" v-on:click="getReportsByDays(365)">1Y</button>
                            <button class="inline-block px-4 py-2 mx-2 font-bold rounded text-gray hover:bg-blue-700" :class="{'bg-yellow':active_filter==500}" v-on:click="getReportsByDays(500)">ALL</button>
                        </div>
                    </div>
                </div>
                <div class="w-full h-96">
                    <vue3-chart-js
                        ref="chartRef"
                        :id="lineGraphChart.id"
                        :type="lineGraphChart.type"
                        :data="lineGraphChart.data"
                        :options="lineGraphChart.options"
                        @before-render="beforeRenderLogic"
                    ></vue3-chart-js>
                </div>
            </div>
        </div>
        <div class="container relative px-4 pt-5 mx-auto">
            <div class="md:flex">
                <div class="w-full pr-4 md:w-2/4">
                    <h2 class=" my-7 text-enriqueto_green">Descripción</h2>
                    <p>{{first_fruit.description}}</p>
                </div>
                <div class="w-full pt-20 pl-4 border-l md:w-2/4 border-gray">
                    <p>{{second_fruit.description}}</p>
                </div>
            </div>
            <hr class="mt-8 border-light_gray"/> 
            
        </div>
    </layout>

</template>

<script>
import Layout from '../../Components/Shared/Layout.vue'
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue'
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import useApi from '../../Services/useApi'
import usePriceFormat, { usePriceCovert } from '../../Services/usePriceFormat'
import { useStore } from 'vuex'
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: { Layout,Vue3ChartJs,Link,ButtonComponent },
    props: ['first_fruit','second_fruit'],
    setup (props) {
    const chartRef = ref(null)
    const active_filter = ref(7)
    const api = useApi()
    const store = useStore()
    watch(()=>store.state.currency, function() {
        getReportsByDays(active_filter.value)
    });
    let first_value_report = props.first_fruit.last_reports.map(({ value }) => value)
    let second_value_report = props.second_fruit.last_reports.map(({ value }) => value)
    let date_report = props.first_fruit.last_reports.map(({ created_at }) => created_at)
    const lineGraphChart = {
        id: 'lineGraph'+props.first_fruit.id,
        type: 'line',
        data: {
            labels: date_report,
            datasets: [{ 
                label:props.first_fruit.name,
                data: first_value_report,
                borderColor: "#4F4F4F",
                fill: true,
                pointBackgroundColor: "#4F4F4F",
                pointRadius: 2.5,
                backgroundColor: 'rgba(242, 153, 74, 0.4)',
                hoverBackgroundColor: 'rgba(33, 150, 83, 0.6)',
                borderWidth: 1
            },
            { 
                label:props.second_fruit.name,
                data: second_value_report,
                borderColor: "#4F4F4F",
                fill: true,
                pointBackgroundColor: "#4F4F4F",
                pointRadius: 2.5,
                backgroundColor: 'rgba(33, 150, 83, 0.24)',
                hoverBackgroundColor: 'rgba(255, 246, 176, 0.6)',
                borderWidth: 1
            }
            ]
        },
        options: {
            elements: {
                line: {
                    tension: 0.6
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
            mode: 'index',
            intersect: false
            },
            scales: {
            x: {
                display: true,
            },
            y: {
                display: true,
            }
            }
        },
    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

    const getReportsByDays = (days)=>{
        active_filter.value = days
        api.getReports(props.first_fruit.id,days)
        .then(function (response) {
            console.log(response);
            lineGraphChart.data.labels = response.reports.map(({ created_at }) => created_at)
            lineGraphChart.data.datasets[0].data= response.reports.map(({ value }) => {return usePriceCovert(value,store.state.currency)});
        })

        api.getReports(props.second_fruit.id,days)
        .then(function (response) {
            console.log(response);
            lineGraphChart.data.datasets[1].data = response.reports.map(({ value }) => {return usePriceCovert(value,store.state.currency)});
            chartRef.value.update(250)
        })
    }

        return {
            lineGraphChart,
            beforeRenderLogic,
            getReportsByDays,
            chartRef,
            usePriceFormat,
            active_filter
        }
    },
}
</script>

<style>

</style>